export default __webpack_public_path__ + "static/media/magazine(1).f6dbd1d8.jpg";